import {Injectable} from "@angular/core";
import {catchError, map, Observable, of} from "rxjs";
import {environment} from "src/environments/environment";
import {CalendarEventAPI} from "../dto/calendar-event.dto";
import {BaseHttpService} from "src/app/shared/infrastructure/services/http/base-http.service";

@Injectable({providedIn: 'root'})
export class CalendarEventApiService extends BaseHttpService {

  readonly baseUrl = `${environment.apiV2URL}/events`;

  getEventById(eventId: string): Observable<CalendarEventAPI | null> {
    return this.get<CalendarEventAPI>(`${eventId}`).pipe(
      map((response) => response ?? null),
      catchError(() => of(null))
    );
  }
}
